<!-- eslint-disable vue/multi-word-component-names -->
<script setup>
import ContactBox from "./ContactBox.vue";
const nameWhatsapp = "whatsapp";
const linkInsta = 'https://instagram.com/emixgraphics?igshid=ZGUzMzM3NWJiOQ=='
const linkBehance = "https://www.behance.net/emmanuelonu1"
const nameInsta = "instagram";
const nameFacebk = "Facebook";
const nameBehance = "behance";
const iconWhatsapp = "bi bi-whatsapp";
const iconInsta = "bi bi-instagram";
const iconFacebk = "bi bi-facebook";
const iconBehance = "bi bi-behance";

const redirectToWhatsApp = () => {
  const phoneNumber = '+2349036960978';  // WhatsApp phone number
  const message = encodeURIComponent('Hello, I want to hire you.');  // Encode the message text

  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  window.open(whatsappUrl, '_blank');
};

</script>

<template>
  <div class="w-full h-auto">
    <div class="flex flex-wrap justify-center items-center my-10">
      <h1 class="text-2xl text-white font-semibold my-2 nav-links">
        Contact
        <span class="text-yellow-800">me</span>
      </h1>
    </div>
    <div
      class="w-[85%] flex flex-wrap justify-around items-center"
      :style="{ margin: '50px auto' }"
    >
      <ContactBox :name="nameBehance" :icon="iconBehance" :link="linkBehance"  />
      <ContactBox :name="nameInsta" :icon="iconInsta" :link="linkInsta" />
      <ContactBox :name="nameFacebk" :icon="iconFacebk" />
      <ContactBox :name="nameWhatsapp" :icon="iconWhatsapp" @click="redirectToWhatsApp" />
      <!-- form -->
      <div class="form-ctn w-full my-20">
        <form action="https://formspree.io/f/xrgvdzen" method="POST" >
          <div class="input-ctn">
            <input
              type="text"
              name="Name"
              placeholder="Your Full Name"
              required
              class="p-2 text-white"
            />
          </div>

          <div class="input-ctn">
            <input
              type="email"
              name="Email"
              placeholder="Your Email"
              required
              class="p-2 text-white"
            />
          </div>

          <div class="input-ctn">
            <textarea
              name="Message"
              cols="30"
              rows="10"
              placeholder="Your Message here"
              class="p-4"
            ></textarea>
          </div>

          <div class="input-ctn flex justify-center items-center">
            <button type="submit" class="bg-yellow-800 text-white font-semibold my-10 cursor-pointer hover:bg-transparent hover:border-2 hover:border-white p-4 rounded-xl"> Hire Me </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<style scoped>
.input-ctn{
    width: 100%;
    margin-bottom: 20px;
}

.input-ctn > input[type='text'], input[type='email'] {
    outline: none;
    border-style: ridge;
    border-width: 2px;
    border-color:rgb(240, 231, 231);
    border-radius: 5px;
    width: 100%;
    height: 50px;
    background-color: transparent;
}

.input-ctn input::placeholder{
        margin-top: 10px;
        padding-left: 20px;
        color: rgba(238, 231, 231, 0.839);
}
.input-ctn input:focus{
    border-color:rgb(240, 231, 231);
}

.input-ctn textarea{
    outline: none;
    border-style: ridge;
    border-width: 2px;
   border-color:rgb(240, 231, 231);
    border-radius: 5px;
    background-color: transparent;
    color: rgba(238, 231, 231, 0.839);;
    width: 100%;
    height: 100px;

}


.input-ctn textarea::placeholder{
    padding-top: 10px;
    padding-left: 20px;
    color: rgba(238, 231, 231, 0.839);
}

.input-ctn textarea:focus{
   border-color:rgb(240, 231, 231);
}

.input-ctn > input[type='submit'] {
    border-radius: 5px;
    outline: none;
    width: 120px;
    height: 40px;
    text-align: center;
    padding: 8px;
    transition: 1s;
}


</style>
